<div class="typeahead-wrapper">
  <input
    type="text"
    class="w-100 form-element z-depth-1"
    autocomplete="off"
    id="{{ id }}"
    tabindex="0"
    role="combobox"
    [attr.aria-expanded]="false"
    [attr.aria-autocomplete]="'list'"
    [attr.aria-owns]="id + '__results-list'"
    [(ngModel)]="searchQuery"
    (focus)="onSearchInputFocused()"
    (keydown)="onSearchInputKeyDown($event)"
    (keyup)="onSearchInputKeyUp($event)"
    #searchInput
  />
  @if (searchQuery && isInputFocused) {
    <div id="{{ id + '__results-list' }}" class="typeahead-results" role="listbox" #resultsList>
      @for (item of data; track $index; let i = $index) {
        <div
          [ngClass]="{ hover: hoverItemIndex === i }"
          (click)="onResultsSelected(item)"
          (mouseenter)="onResultsMouseEnter(i)"
          (mouseleave)="onResultsMouseLeave(i)"
        >
          <ng-container *ngTemplateOutlet="resultRowTpl; context: { $implicit: item }"></ng-container>
        </div>
      }
      @if (data && data.length === 0 && !hideNoResults) {
        <div class="no-results">
          {{ 'no_results_found' | translate }}
        </div>
      }
    </div>
  }
</div>
